<template>
  <div class="start-sign">
    <div class="scroll-content">
      <div class="wrapper">
        <div class="btns">
          <van-button
            type="default"
            class="clear"
            @click="clear"
            style="color: #0064dc"
          >
            <span>重</span>
            <span>签</span>
          </van-button>
          <van-button
            type="info"
            @click="doSave"
          >
            <span>确</span>
            <span>定</span>
          </van-button>
        </div>
        <div
          class="sign-content"
          ref="canvasBox"
        >
          <canvas class="canvasId" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dataURLtoBlob } from '@/utils/exif';
// import { upload } from '@/utils/oss.js';
import SignaturePad from 'signature_pad';
import UploadHelper from '@/common/upload-helper.js';

export default {
  name: 'Sign',
  data() {
    return {
      SignaturePad: null,
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(250,250,250)'
      },
      committed: false,
      loading: false,
      imgURL: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.getCanvas();
      }, 500);
    });
    localStorage.setItem('isSign', '1');
  },
  async created() {
  },
  methods: {
    getCanvas() {
      const canvas = document.querySelector('.canvasId');
      this.signaturePad = new SignaturePad(canvas, this.config);
      canvas.height = this.$refs.canvasBox.clientHeight;
      canvas.width = this.$refs.canvasBox.clientWidth;
    },
    clear() {
      this.signaturePad.clear();
    },
    doSave() {
      if (this.loading) return;
      this.loading = true;
      this.save().finally(() => {
        this.loading = false;
      });
    },
    async save() {
      if (this.signaturePad.isEmpty()) {
        return this.$toast('电子签名不能为空');
      }
      const src = this.signaturePad.toDataURL();
      const png = await this.rotateImg(src);
      const file = dataURLtoBlob(png);
      const currTime = new Date().getTime();
      file.name = currTime + '.png'; // 给图片命名
      const res = await UploadHelper(file);
      if (!res.accessUrl) {
        this.$toast('电子签名上传失败');
        return;
      }
      localStorage.setItem(`${this.$route.query.type}Path`, res.accessUrl);
      localStorage.setItem(`${this.$route.query.type}PicId`, res.picId);
      this.$toast('签名成功');
      this.$router.go(-1);
    },
    rotateImg(src) {
      return new Promise((resolve, reject) => {
        // 创建画布元素
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 加载原始图像
        const img = new Image();
        img.src = src; // 设置图像路径

        // 等待图像加载完成后执行旋转并重新上传的逻辑
        img.onload = function() {
          const angle = -90; // 设定旋转角度（单位为度）

          // 将图像绘制到画布上
          canvas.height = img.width;
          canvas.width = img.height;
          ctx.drawImage(img, 0, 0);

          // 旋转图像
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate((Math.PI * angle) / 180);
          ctx.drawImage(img, -(img.width / 2), -(img.height / 2));

          // 获取旋转后的数据URL
          const rotatedDataUrl = canvas.toDataURL();

          resolve(rotatedDataUrl);
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.start-sign {
  .sign {
    position: relative;
  }

  .btns {
    padding: 0 10px 24px 9px;
    border-right: 1px solid #E8E8E8;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    button {
      line-height: normal;
      font-size: 15px;
      border-radius: 8px;
      &:last-of-type {
        margin-top: 16px;
      }
      background: #4398ff;
      color: #ffffff;
      height: 150px;
      width: 40px;
      .van-button__text{
        display: flex;
        transform: rotate(90deg);
      }
    }
    .clear {
      border: 1px solid #999999;
      background: #ffffff;
      .van-button__text {
        color: #999999;
      }
    }
  }

  .wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex: 59px 0 0;
  }

  .sign-content {
    width: 100%;
    height: 100%;
  }
  .scroll-content {
    height: calc(100vh - 46px);
    display: block;
  }
}
</style>
